import s, { forwardRef as c } from "react";
import { P as a } from "./index-CZzwT3Oj.mjs";
function l() {
  return l = Object.assign || function(r) {
    for (var o = 1; o < arguments.length; o++) {
      var t = arguments[o];
      for (var e in t)
        Object.prototype.hasOwnProperty.call(t, e) && (r[e] = t[e]);
    }
    return r;
  }, l.apply(this, arguments);
}
function u(r, o) {
  if (r == null) return {};
  var t = g(r, o), e, n;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(r);
    for (n = 0; n < i.length; n++)
      e = i[n], !(o.indexOf(e) >= 0) && Object.prototype.propertyIsEnumerable.call(r, e) && (t[e] = r[e]);
  }
  return t;
}
function g(r, o) {
  if (r == null) return {};
  var t = {}, e = Object.keys(r), n, i;
  for (i = 0; i < e.length; i++)
    n = e[i], !(o.indexOf(n) >= 0) && (t[n] = r[n]);
  return t;
}
var f = c(function(r, o) {
  var t = r.color, e = t === void 0 ? "currentColor" : t, n = r.size, i = n === void 0 ? 24 : n, p = u(r, ["color", "size"]);
  return /* @__PURE__ */ s.createElement("svg", l({
    ref: o,
    xmlns: "http://www.w3.org/2000/svg",
    width: i,
    height: i,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: e,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, p), /* @__PURE__ */ s.createElement("path", {
    d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
  }));
});
f.propTypes = {
  color: a.string,
  size: a.oneOfType([a.string, a.number])
};
f.displayName = "Triangle";
export {
  f as T
};
